import React from 'react'
import ReactDOM from 'react-dom/client'
import {BrowserRouter} from 'react-router-dom'
import {Provider} from 'react-redux'
import {store} from './store'
import {logout} from './store/slices/authSlice'
import App from './App'
import './index.css'
import {getApiService, initializeApiService} from './services/api'

// Initialize the API service
initializeApiService({
  clientConfig: {
    baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:9015/api',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
  },
  enableLogging: import.meta.env.DEV,
  getState: store.getState,
  dispatch: store.dispatch,
  onAuthError: (error) => {
    if (error.status === 401) {
      // Redirect to login page if unauthorized
      window.location.href = '/';
    }
  },
})

// Get the initialized API service
const apiService = getApiService();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
)
